export default {
  objects: state => {
    return state.objects;
  },
  objectById: state => id => {
    if (state.objects && typeof state.objects[id] !== 'undefined') {
      return state.objects[id];
    }

    return null;
  },
  objectTypes: state => {
    return state.objectTypes;
  },
  objectsByObjectType: state => objectTypeId => {
    const arr = [];
    Object.keys(state.objects).forEach(key => {
      const obj = state.objects[key];
      if (parseInt(obj.object_type_id) === parseInt(objectTypeId)) {
        arr.push(obj);
      }
    });

    arr.sort((a, b) => {
      if (a.name > b.name) {
        return 1;
      }

      return -1;
    });

    return arr;
  },
  serialized: state => {
    return state.serialized;
  },
  combineFunctions: state => {
    return state.combineFunctions;
  },
  adjustmentFunctions: state => {
    return state.adjustmentFunctions;
  },
  groups: state => {
    return state.groups;
  },
  groupsWithItems: state => {
    return state.groups.filter(item => {
      return item.items.length > 0;
    });
  },
  groupById: state => id => {
    const filtered = state.groups.filter(item => {
      return parseInt(item['id']) === parseInt(id);
    });

    return filtered && filtered.length > 0 ? filtered[0] : null;
  },
  groupsByBoardId: state => id => {
    const filtered = state.boards.filter(item => {
      return parseInt(item['id']) === parseInt(id);
    });

    if (!filtered || filtered.length < 1) {
      return [];
    }

    const ret = [];
    filtered[0].items.forEach(assignment => {
      const filtered = state.groups.filter(item => {
        return parseInt(item['id']) === parseInt(assignment['group_id']);
      });

      if (filtered.length === 1) {
        ret.push(filtered[0]);
      }
    });

    return ret;
  },
  boards: state => {
    return state.boards;
  },
  boardById: state => id => {
    const filtered = state.boards.filter(item => {
      return parseInt(item['id']) === parseInt(id);
    });

    return filtered && filtered.length > 0 ? filtered[0] : null;
  },
  chartTypeByObjectId: state => id => {
    if (!state.objects[id]) {
      return null;
    }

    let chartType = 'liniar';
    const object = state.objects[id];
    switch (parseInt(object.object_type_id)) {
      case 19:
        chartType = 'gantt';
        break;
      default:
        break;
    }

    return chartType;
  }
};